<nz-card>
  <h2>{{ 'ACCOUNT_SETTINGS.DANGER.TITLE' | translate }}</h2>
  <p class="section-description">{{ 'ACCOUNT_SETTINGS.DANGER.DESCRIPTION' | translate }}</p>

  <app-account-deletion></app-account-deletion>
</nz-card>
